package br.com.vvrefeicoes.portal.data.repository

import br.com.vvrefeicoes.portal.domain.repository.AuthRepository
import br.com.vvrefeicoes.portal.domain.repository.JuridicoCreditoRepository
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.get
import io.ktor.client.request.header
import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.bodyAsText
import io.ktor.http.HttpHeaders
import io.ktor.http.isSuccess
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json

class RemoteJuridicoCreditoRepository(
    private val httpClient: HttpClient,
    private val baseUrl: String,
    private val authRepository: AuthRepository,
) : JuridicoCreditoRepository {
    override suspend fun credits(): Double? =
        request { httpClient.get("$baseUrl/juridico/creditos") { authorize() } }
            .body<CreditDto>()
            .saldo

    private suspend inline fun request(crossinline call: suspend () -> HttpResponse): HttpResponse {
        val response = call()
        if (!response.status.isSuccess()) {
            val message =
                runCatching {
                    Json { ignoreUnknownKeys = true }.decodeFromString<JuridicoCreditoApiError>(response.bodyAsText()).message
                }.getOrNull()
            error(message ?: "HTTP ${response.status.value}")
        }
        return response
    }

    private fun HttpRequestBuilder.authorize() {
        authRepository.session.value
            ?.token
            ?.let { header(HttpHeaders.Authorization, "Bearer $it") }
    }
}

@Serializable
private data class JuridicoCreditoApiError(
    val message: String? = null,
)

@Serializable
private data class CreditDto(
    val saldo: Double? = null,
)
